import {usePdfDownloader} from "@/entity/pdf";
import {
	BusinessSalesGoalForm,
	BusinessSalesMonthForm,
	BusinessSalesWeekForm,
	BusinessSalesYearForm,
	BusinessSearchForm
} from "@/features/business";
import {filterValidValuesToObject} from "@/shared/lib";
import {vars} from "@/shared/lib/theme.css";
import {BusinessSearchType} from "@/shared/model";
import {Button, Column, Row} from "@/shared/ui";
import {createFileRoute, useSearch} from "@tanstack/react-router";
import {Suspense} from "react";

export const Route = createFileRoute("/(auth)/_layout/business/")({
	component: BusinessScreen,
	validateSearch: (search: Partial<BusinessSearchType>): Partial<BusinessSearchType> => {
		return filterValidValuesToObject<BusinessSearchType, BusinessSearchType>(search);
	}
});

function BusinessScreen() {
	const search = useSearch({
		from: "/(auth)/_layout/business/",
		select: (search) => search,
		strict: true
	});

	const {ref, downloadPdf} = usePdfDownloader({
		fileName: "목표관리.pdf"
	});
		
	return (
		<Column ref={ref} fullWidth style={{gap: vars.size[32]}}>
			<Column
				fullWidth
				style={{
					position: "sticky",
					top: 0,
					zIndex: 100,
					backgroundColor: vars.color.white,
					paddingBottom: vars.size[16]
				}}
			>
				<BusinessSearchForm />

				<Row
					fullWidth
					style={{
						justifyContent: "flex-end",
						gap: vars.size[8],
						padding: vars.size[4]
					}}
				>
					<Button color="third" onClick={downloadPdf}>
						{"다운로드"}
					</Button>
				</Row>
			</Column>

			<Suspense>
				<BusinessSalesGoalForm />
			</Suspense>
			{search.period === "WEEKLY" && (
				<Suspense>
					<BusinessSalesWeekForm />
				</Suspense>
			)}
			{search.period === "MONTHLY" && (
				<Suspense>
					<BusinessSalesMonthForm />
				</Suspense>
			)}
			{search.period === "YEARLY" && (
				<Suspense>
					<BusinessSalesYearForm />
				</Suspense>
			)}
		</Column>
	);
}
